import { createSlice } from '@reduxjs/toolkit';

const crtUserSlice = createSlice({
  name: 'crtUser',
  initialState: {
    uid: localStorage.getItem('user.uid'),
    displayName: '',
    email: '',
    photoURL: null,
    providerId: null,
    shouldAskToSignIn: false,
    desiredAction: null,
  },
  reducers: {
    setShouldAskToSignIn(state, action) {
      state.shouldAskToSignIn = true
      state.desiredAction = action.payload.action
    },
    resetShouldAskToSignIn(state) {
      state.shouldAskToSignIn = false
      state.desiredAction = null
    },
    setCrtUser(state, action) {
      state.uid = action.payload.uid
      state.displayName = action.payload.displayName
      state.email = action.payload.email
      state.photoURL = action.payload.photoURL

      if (action.payload.providerData && action.payload.providerData.length) {
        state.providerId = action.payload.providerData[0].providerId
      }

      localStorage.setItem('user.uid', action.payload.uid)
    },
    resetCrtUser(state) {
      state.uid = null
      state.displayName = null
      state.email = null
      state.photoURL = null
      state.providerId = null
    }
  },
})

export default crtUserSlice
